import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import PhotoDetails from 'dibs-interiors-photos/exports/PhotoDetails.tsx';

import { type PhotoDetailsWrapper_photoNode$key } from './__generated__/PhotoDetailsWrapper_photoNode.graphql.ts';

type Props = {
    photoNode: PhotoDetailsWrapper_photoNode$key | null | undefined;
};

const PhotoDetailsWrapper: FC<Props> = props => {
    const { photoNode: photoNodeRef } = props;

    const photoNode = useFragment(
        graphql`
            fragment PhotoDetailsWrapper_photoNode on TradePhotosQueryOutput {
                photo {
                    name
                    styles {
                        name
                        urlLabel
                    }
                    room {
                        name
                        urlLabel
                    }
                }
            }
        `,
        photoNodeRef
    );

    const photo = photoNode?.photo;
    const photoName = photo?.name || photo?.room?.name;
    const styleTag = photo?.styles?.[0];
    const roomTag = photo?.room;

    return <PhotoDetails styleTag={styleTag} roomTag={roomTag} photoName={photoName || ''} />;
};

export default PhotoDetailsWrapper;
